import { Mail, Phone, Instagram, Linkedin } from "lucide-react";
import { Separator } from "../components/ui/separator";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_obiter-clat/artifacts/lfcvtw4r_PHOTO-2026-01-28-20-29-49.jpg";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-zinc-50 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="The Obiter"
                data-testid="footer-logo"
                className="h-10 w-10 rounded-full object-cover"
              />
              <span className="font-heading text-lg font-semibold text-zinc-900">
                The Obiter
              </span>
            </div>
            <p className="font-body text-sm text-zinc-500 leading-relaxed max-w-sm">
              Mentorship-led CLAT preparation focused on structured strategy,
              personal attention, and career clarity for serious aspirants.
            </p>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href="mailto:theobiter.edu@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 font-body text-sm text-zinc-600 hover:text-orange-600 transition-colors"
              >
                <Mail size={16} strokeWidth={1.5} className="text-orange-500" />
                theobiter.edu@gmail.com
              </a>
              <a
                href="https://wa.me/918989911780"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-3 font-body text-sm text-zinc-600 hover:text-orange-600 transition-colors"
              >
                <Phone size={16} strokeWidth={1.5} className="text-orange-500" />
                +91 8989911780
              </a>
            </div>
          </div>

          {/* Social */}
          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Follow Us
            </h4>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/the_obiter_?igsh=czdjNnp3d3FneDU2&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-white border border-zinc-200 flex items-center justify-center hover:border-orange-300 hover:bg-orange-50 transition-all"
              >
                <Instagram size={16} strokeWidth={1.5} className="text-zinc-600" />
              </a>
              <a
                href="https://www.linkedin.com/company/the-obiter/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-full bg-white border border-zinc-200 flex items-center justify-center hover:border-orange-300 hover:bg-orange-50 transition-all"
              >
                <Linkedin size={16} strokeWidth={1.5} className="text-zinc-600" />
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-zinc-200" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            data-testid="footer-disclaimer"
            className="font-body text-xs text-zinc-400"
          >
            This is an independent mentorship initiative.
          </p>
          <p className="font-body text-xs text-zinc-400">
            &copy; {new Date().getFullYear()} The Obiter. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
